export default __webpack_public_path__ + "static/media/Dr._D_Whalen.fa976360.jpg";